export default "__VITE_ASSET__B9k3c29d__"